import React,{useState, useContext} from 'react';

import {  
  Card,  
  Button,
  Badge,
  Row,
  Col,
  Alert,
  ProgressBar,
  Spinner
} from 'react-bootstrap';
import UserContext from './../../contexts/UserContext';
import {Uploader} from '../../components';
import Utils from '../../Utils';
import _ from 'lodash';

const Step2 = (props) => {

  const [scorm,setScorm] = useState('');

  const [uploading,setUploading] = useState(false);
  const filesize_in_mb =  _.get(process.env,'REACT_APP_MAX_PDF_PPT_SIZE',1);
  const [errMsg,setErrMsg] = useState('');
  const scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  const {getPkgSize} = useContext(UserContext);

  const renderInfo = () => {
    return <Card className="card-box blk text-center">
      <Card.Body className="p-5">        
        <h3 className="mt-3 mb-5">Upload PPT / PDF </h3>

        <p><strong>Upload your PPT or PDF</strong> file to generate images per page.</p>

        <p>All pages of the PDF/PPT will be converted into flat images, you can sort/manage each slide in the next step.</p>
        <p className="ylo"><i><strong>Maximum PPT/PDf file size is {filesize_in_mb}MB.</strong></i></p>
      </Card.Body>  
    </Card>
  }

  const onUploadFile = (attr,status) => {         
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${filesize_in_mb} MB. Try again with an acceptable sized file.`);
      window.setTimeout(function(){
        setErrMsg('');
        setUploading('Please wait');
      }, 1000);
    }else{
        let file_size = (status.size/1024/1024).toFixed(1);
        let tot_size = parseInt(file_size) + getPkgSize();
        if(tot_size > scormsize_in_mb){
          setErrMsg(`Total SCROM size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
          return;
        }else{
          setErrMsg('');   
          var data = JSON.parse(attr);    
          setScorm(data.fname);
          props.onUpload(data);
          setUploading(false);
        }   
    }
  }

  const errEmpty = () =>{
    setErrMsg('');
  }

  const startUploading = (attr,status) => { 

    if(status=='rejected_file_type'){
      setUploading(false);
      window.alert("Invalid file type upload!\nPlease try again!");
    }else{
      setUploading('Please wait.. we are processing your file..');
    }    
  }


  const renderUploadPPT = () => {
    return <>   
    <div  className="uploadPPT">
    <Row>
      <Col lg={10} className="text-center">
      {errMsg !== ''  && <>
      <Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" />{errMsg} </Alert>
        </>}
        {(uploading && errMsg === '') && <Alert className="p-0 m-0"> {uploading}  <Spinner animation="border" variant="dark" /><br />
        {/* <ProgressBar animated variant="warning" now={100} /> */}
        </Alert>}
        {!uploading && <>
          {(scorm === '' && errMsg ==='') && <>
            No File selected.
          </>}
          {scorm!=='' && <>            
            Uploading Your file... <span className="fa fa-arrow-up"/> <span className="fa fa-close clickable" title="Remove" onClick={() => onUploadFile('')} />
          </>}
        </>}  
      </Col> 
      {uploading===false && <Col lg={2} className="text-right"></Col>}
    </Row> 
      <div>
        
        <Uploader 
        accept=".ppt,.pptx,.pdf" 
        instructions={`To upload your PPT/PDF (max. ${filesize_in_mb} MB), click here or drag/drop your file here`}
        maxSizeBytes={filesize_in_mb*1024*1024} 
        uploadUrl={Utils.apiUrl('processfile')} 
        onUpload={onUploadFile} 
        onSubmit={startUploading}
        onClick={errEmpty} />
      </div>
      </div>
    </>;
  }
  
  return <Row className="uploadImageVideopage">
    <Col className="mt-3">{renderInfo()}</Col>
    <Col className="mt-3">{renderUploadPPT()}</Col>
  </Row>;
}

export default Step2;